// extracted by mini-css-extract-plugin
export var intro = "sticky-intro-module--intro--1221b";
export var spin = "sticky-intro-module--spin--93b2c";